var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.41421 0.343138L7.70711 1.05024L12.1583 5.50148H0.427443V6.4985H12.1583L7.70711 10.9497L8.41421 11.6568L14.0711 5.99999L8.41421 0.343138Z","fill":"white"}));
}

ArrowRightInline.defaultProps = {"width":"15","height":"12","viewBox":"0 0 15 12","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
